import createCRUDObservable from 'redux-observable-crud'
import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs'
import ReEnrollFromDisenrollmentsActions, { ReEnrollFromDisenrollmentsRedux, ReEnrollFromDisenrollmentsTypes } from '../Redux/ReEnrollFromDisenrollmentsRedux'
import { notificationSuccess } from '../Redux/NotificationActions'
import DisenrollmentsActions from '../Redux/DisenrollmentsRedux'
import ClassroomActions from '../Redux/ClassroomRedux'

const reEnrollFromDisenrollmentsCrudObservable = createCRUDObservable({
  mainRedux: ReEnrollFromDisenrollmentsRedux,
  reduxPath: 'reEnrollFromDisenrollments',
})

const postReEnrollFromDisenrollmentsEpic = (action$, store, { Api }) =>
  action$.ofType(ReEnrollFromDisenrollmentsTypes.reEnrollFromDisenrollmentsRequest)
    .mergeMap(({ studentId, data }) => (
      Observable
        .fromPromise(Api.reEnrollFromDisenrollments.postReEnrollFromDisenrollments(studentId, data)
          .then(result => result)
          .catch(error => error))
        .flatMap((result) => {
          const { status } = result
          if (!(status >= 200 && status < 300)) {
            return [ReEnrollFromDisenrollmentsActions.reEnrollFromDisenrollmentsFailure(result.error)]
          }
          const { data: { data: payload } } = result
          return [
            ReEnrollFromDisenrollmentsActions.reEnrollFromDisenrollmentsSuccess(payload),
            notificationSuccess('Alumno Registrado'),
            DisenrollmentsActions.updateDataAfterInscription(payload),
            ClassroomActions.updateDataAfterInscription(payload),
          ]
        })
    ))


export const reEnrollFromDisenrollmentsObservers = Object.assign({}, reEnrollFromDisenrollmentsCrudObservable.observers, {
  postReEnrollFromDisenrollmentsEpic,
})

export const reEnrollFromDisenrollmentsEpic = combineEpics(
  postReEnrollFromDisenrollmentsEpic,
)



// WEBPACK FOOTER //
// ./src/Data/Observables/ReEnrollFromDisenrollmentsObservable.js